<script>
	import API from '../../States/API';
	import Config from '../../Models/Config';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';
	import Trigger from '../../Models/Trigger';

	export let index = 0;

	let slide = {};
	let pass = {};
	let active = false;
	let forgotten = false;
	let forgotten_sent = false;
	let show_pass = false;

	function showPass() {
		const visible = pass.getAttribute('type') == 'text';
		pass.setAttribute('type', visible ? 'password' : 'text')
		show_pass = !visible;
	}

	async function signIn(event) {
		const config = Config.labels.sign_in;
		const data = Helper.form(event.target);
		const response = await API.signIn(data);
		if (response.success) {
			const prefix = config.success.prefix;
			const suffix = config.success.suffix;
			const message = prefix + response.data.name + suffix;
			Trigger.event('alert', {icon: 'comment-check', message});
			Slider.route('start');
		}

		else {
			const message = config.error;
			Trigger.event('alert', {icon: 'comment-exclamation', message});
		}
	}

	async function forgot(event) {
		const config = Config.labels.forgot;
		const data = Helper.form(event.target);
		const response = await API.forgot(data);
		if (response.success) {
			forgotten_sent = true;
			forgotten = false;
		}

		else {
			const message = config.error;
			Trigger.event('alert', {icon: 'comment-exclamation', message});
		}
	}

	function updateSlider(slides) {
		slide = slides[`slide_${index}`].properties;
		active = slide.active;
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	h2.duck {
		margin-top: 2em;
	}

	div.button.question {
		text-align: left;
		text-transform: none;
	}

	div.panel {
		display: flex;
		justify-content: space-between;
		margin-bottom: 3em;
	}

	div.panel .button {
		margin-bottom: 0;
	}

	div.panel.sign-in {
		margin-bottom: .5em;
	}

	div.panel.sign-in > input,
	div.panel.sign-in > div.group {
		width: calc(40% - .67em);
	}

	div.panel.sign-in > div.group {
		position: relative;
	}

	div.panel.sign-in > div.group i {
		position: absolute;
		top: 1em;
		right: 1em;
		cursor: pointer;
	}

	div.panel.sign-in .button {
		width: calc(20% - .67em);
	}

	div.notice.forgotten {
		margin-bottom: 2.75em;
	}

	div.panel.forgotten input {
		width: calc(70% - .5em);
	}

	div.panel.forgotten .button {
		width: calc(30% - .5em);
		margin-bottom: 0;
	}

	:global(html.light div.box.authentication .button.facebook) {
		color: #FFF;
		background-color: #4267B2 !important;
	}

	:global(html.light div.box.authentication .button.google) {
		color: #FFF;
		background-color: #DB4437 !important;
	}

	@media (max-device-width: 1024px) {
		div.panel {
			flex-direction: column;
		}

		div.panel .button,
		div.panel input,
		div.panel div.group {
			width: 100% !important;
			margin-bottom: .5em;
		}

		div.panel .button {
			padding-top: 1em;
			padding-bottom: 1em;
		}
	}
</style>

<div class="box authentication feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Inloggen</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		<h1>Inloggen</h1>
		<p>Log in als je verzen wilt markeren en/of er aantekeningen bij wilt maken.</p>
		<h2>Met e-mailadres en wachtwoord.</h2>
		<p>Log hieronder in op je account.</p>
		<form name="sign_in_form" on:submit|preventDefault="{signIn}">
			<div class="panel sign-in">
				<input type="email" name="mail" required="required" placeholder="E-mailadres"/>
				<div class="group">
					<input bind:this="{pass}" type="password" name="pass" required="required" placeholder="Wachtwoord"/>
					<i on:click="{event => showPass()}" class="fad {show_pass ? 'fa-eye-slash' : 'fa-eye'}"></i>
				</div>
				<button class="button primary solid" type="submit" disabled="{$API.busy}">
					<i class="fad fa-sign-in"></i> Inloggen
				</button>
			</div>
		</form>
		<div class="button question" on:click="{event => forgotten = !forgotten}">
			<i class="fad fa-question-circle"></i> Ben je jouw wachtwoord vergeten?
		</div>
		{#if forgotten}
			<h2 class="duck">Wachtwoord vergeten?</h2>
			<p>Vul hier je e-mailadres zodat we je een mailtje kunnen sturen om een nieuw wachtwoord aan te maken.</p>
			<form name="forgot_form" on:submit|preventDefault="{forgot}">
				<div class="panel forgotten">
					<input type="email" name="mail" placeholder="E-mailadres"/>
					<button class="button" type="submit">
						<i class="fad fa-paper-plane"></i> Mailen
					</button>
				</div>
			</form>
		{/if}
		{#if forgotten_sent}
			<h2 class="duck">Bedankt, controleer jouw e-mail berichten.</h2>
			<p>Als jouw e-mailadres in onze database voorkomt dan zal je binnen enkele minuten een e-mail van ons ontvangen.</p>
			<div class="notice forgotten">
				<i class="fad fa-info-circle"></i> Geen e-mail ontvangen? Controleer dan jouw spam berichten en of je het juiste e-mailadres hebt ingevuld.
			</div>
		{/if}
		<h2 class="duck">Heb je nog geen account?</h2>
		<p>Maak dan eerst een account aan via Registreren.</p>
		<div class="button primary solid" on:click="{event => Slider.route('signUp')}">
			<i class="fad fa-user-plus"></i> Naar registreren
		</div>
	</div>
</div>